import { render, staticRenderFns } from "./TicketWhatsappLog.vue?vue&type=template&id=14c0c32c&scoped=true&"
import script from "./TicketWhatsappLog.vue?vue&type=script&lang=js&"
export * from "./TicketWhatsappLog.vue?vue&type=script&lang=js&"
import style0 from "./TicketWhatsappLog.vue?vue&type=style&index=0&id=14c0c32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c0c32c",
  null
  
)

export default component.exports